interface Dictionary {
  [name: string]: number;
}

const spreadNameToUpsellProductTypeId = (spreadName: string) => (({
  front: 133,
  back: 134,
  'neck-inner': 502,
  'neck-outer': 503,
  'sleeve-left': 504,
  'sleeve-right': 505,
} as Dictionary)[spreadName]);

export default spreadNameToUpsellProductTypeId;
